// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-camping-index-js": () => import("../src/pages/camping/index.js" /* webpackChunkName: "component---src-pages-camping-index-js" */),
  "component---src-pages-camping-nuevo-js": () => import("../src/pages/camping/nuevo.js" /* webpackChunkName: "component---src-pages-camping-nuevo-js" */),
  "component---src-pages-index-js": () => import("../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

